import { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { map, sortBy, find } from "lodash";
import Grid from "@mui/material/Grid";
import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import * as React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Typography, TextField, FormControl } from "@mui/material";
import { Box } from "@mui/system";
import InputLabel from "@mui/material/InputLabel";
import Button from "@mui/material/Button";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import Checkbox from "@mui/material/Checkbox";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormLabel from "@mui/material/FormLabel";
import {
  getRolesBySiteUuid,
  getUsersByRoleId,
} from "../../Layouts/Users/Services";
import { joinByKeys, getClassNames } from "../../Js/Common";
import {
  fetchUserByClass,
  getSettingsRecord,
  upsertBroadCastRecord,
  insertPodClassData,
} from "./Services";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";
import SettingsIcon from "@mui/icons-material/Settings";

import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import ListItemIcon from "@mui/material/ListItemIcon";
import CircleIcon from "@mui/icons-material/Circle";

import SettingsModal from "./SettingsModal";
import Confirmation from "../../Components/Modal/Confirmation";
import { Approval, Category, Description } from "@mui/icons-material";

const defaultTypes = [
  { value: 0, name: "Primary", classes: [] },
  { value: 1, name: "Middle", classes: [] },
  { value: 2, name: "Secondary", classes: [] },
];

const CreatePodcast = (props) => {
  const classesName = useStyles();
  const navigation = useNavigate();

  const userInfo = useSelector((state) => state.loggedInUserInfo.userInfo);

  const [trainers, setTrainers] = useState([]);
  const [selectedTrainerId, setSelectedTrainerId] = useState([]);
  const [selectedTrainers, setSelectedTrainers] = useState("");
  const [allClasses, setAllClasses] = useState([]);
  const [selectedClass, setSelectedClass] = useState([]);
  const [selectedClassLearners, setSelectedClassLearners] = useState([]);
  const [selectedLearners, setSelectedLearners] = useState([]);
  const [selectedType, setSelectedType] = useState(0);

  const [podcastTitle, setPodcastTitle] = useState(null);
  const [podcastGuestName, setPodcastGuestName] = useState(null);

  const [types, setTypes] = useState(defaultTypes);
  const [tempTypes, setTempTypes] = useState([defaultTypes]);
  const [settingsRecordId, setSettingsRecordId] = useState(null);
  const [modlVisible, setModlVisible] = useState(false);

  const [alertFlag, setAlertFlag] = useState(false);
  const [currentMessage, setCurrentMessage] = useState(null);
  const [confirmModal, setConfirmModal] = useState(false);

  useEffect(() => {
    initialRender();
  }, []);

  // React logic hooks
  useEffect(() => {
    const innerFunction = async () => {
      let allClassesData = await fetchUserByClass({
        query: {
          $select: ["uid", "name", "belongs_to"],
          status: true,
          site_uuid: userInfo.site_uuid,
          belongs_to: {
            $in: map(selectedClass, "id"),
          },
          $limit: -1,
        },
      });

      console.log("allClassesData", allClassesData);

      setSelectedClassLearners(
        sortBy(withClassName(allClassesData.data), [
          "classname",
          (o) => {
            return o.name.firstname;
          },
        ])
      );

      let getTypes = await getSettingsRecord(userInfo.site_uuid);
      if (getTypes?.data?.data && getTypes?.data?.data.length > 0) {
        console.log("lll", getTypes?.data?.data[0]["keydata"]);
        setTypes(
          JSON.parse(JSON.stringify(getTypes?.data?.data[0]["keydata"]))
        );
        setTempTypes(
          JSON.parse(JSON.stringify(getTypes?.data?.data[0]["keydata"]))
        );
        setSettingsRecordId(getTypes?.data?.data[0]["uid"]);
      } else {
        setSettingsRecordId(null);
      }
    };
    innerFunction();
  }, [selectedClass]);

  const withClassName = (learners) => {
    return learners.map((val) => {
      return {
        ...val,
        classname: className(val.belongs_to),
      };
    });
  };

  const className = (id) => {
    let foundObj = find(selectedClass, { id: id });
    if (foundObj) {
      return foundObj.value;
    }
    return "NA";
  };

  const initialRender = useCallback(async () => {
    let trainerUuids = [];
    let resTrainer = await getTrainerRole();
    if (resTrainer) {
      let params = {
        query: {
          $select: ["uid", "name"],
          role_uid: resTrainer.uid,
          site_uuid: userInfo.site_uuid,
          status: true,
          $limit: -1,
        },
      };
      let resUsersData = await getUsersByRoleId(params);
      // console.log("resUsersData===>", resUsersData);
      if (resUsersData.data.length > 0) {
        let trainerUuids = resUsersData.data.map((userData) => {
          delete userData.rolesInfo;
          let newUserData = {};
          newUserData.name = joinByKeys(
            userData.name,
            ["firstname", "lastname"],
            " "
          );
          newUserData.value = userData.uid;
          return newUserData;
        });
        console.log("trainerUuids", trainerUuids);
        setTrainers(trainerUuids);
      }
    }
    let allClassesData = await getClassNames(userInfo.site_uuid);
    let allNewClassesData = allClasses.concat(allClassesData);
    setAllClasses(allNewClassesData);
  }, [userInfo]);

  const getTrainerRole = async () => {
    let params = {
      query: {
        $select: ["uid", "title"],
        title: "Trainer",
        site_uuid: userInfo.site_uuid,
      },
    };
    let resRolesData = await getRolesBySiteUuid(params);
    return resRolesData.data[0];
  };

  const addRemoveLearner = (value) => {
    let selectedlrnr = [...selectedLearners];
    let pos = selectedlrnr.findIndex((o) => o.uid === value.uid);
    if (pos > -1) {
      selectedlrnr.splice(pos, 1);
    } else {
      selectedlrnr.push(value);
    }
    setSelectedLearners(selectedlrnr);
  };

  // select class from list
  const selectClass = async (obj) => {
    let classes = [...selectedClass];
    let pos = classes.findIndex((o) => o.id === obj.id);
    if (pos > -1) {
      classes.splice(pos, 1);
    } else {
      classes.push(obj);
    }
    setSelectedClass(classes);
  };

  // select class from list for Settings
  const selectClassToSave = async (obj, index, str) => {
    let typesTemp = [...tempTypes];
    if (str == "classes") {
      let selectedTypeClasses = [...typesTemp[index]["classes"]];
      let pos = selectedTypeClasses.findIndex((o) => o.id === obj.id);
      if (pos > -1) {
        selectedTypeClasses.splice(pos, 1);
      } else {
        selectedTypeClasses.push(obj);
      }
      typesTemp[index]["classes"] = [...selectedTypeClasses];
    } else {
      typesTemp[index]["name"] = obj;
    }
    setTempTypes(typesTemp);
  };

  const saveSettings = async () => {
    let res = await upsertBroadCastRecord(
      tempTypes,
      userInfo.site_uuid,
      userInfo.uid,
      settingsRecordId
    );

    if (res?.status == 200) {
      setModlVisible(false);
      setTypes(tempTypes);
      setSelectedClass([]);
      setSelectedClassLearners([]);
      setSelectedLearners([]);
    }
  };

  const validateForm = async () => {
    if (!podcastTitle || (podcastTitle && podcastTitle.length == 0)) {
      setAlertFlag(true);
      setCurrentMessage("Please give a title.");
      return false;
    }
    console.log("selectedTrainers", selectedTrainers);
    if (!selectedTrainers) {
      setAlertFlag(true);
      setCurrentMessage("Please select a trainer for approval.");
      return false;
    }
    if (
      !selectedLearners ||
      (selectedLearners && selectedLearners.length == 0)
    ) {
      setAlertFlag(true);
      setCurrentMessage("Please select minimum 1 learner.");
      return false;
    }

    let objToSave = {
      site_uuid: userInfo.site_uuid,
      verb: "newsPodcast",
      context: {
        title: podcastTitle,
        description: "",
        user_uuid: selectedLearners.map((val) => {
          return val.uid;
        }),
        guest: podcastGuestName,
        category: selectedType,
      },
      created_by: userInfo.uid,
      approval_by: selectedTrainers,
      is_approved: false,
      is_deleted: false,
    };

    let response = await insertPodClassData(objToSave);
    if (response.status == 200) {
      //setConfirmModal(true);
      navigation(-1);
    }
  };

  return (
    <Grid container>
      <Grid container>
        {/* <GenerateMenu menuJson={menuJson} goToSubmenu={goToSubmenu}></GenerateMenu>
            {pathToParentMenu.length > 1 &&
                <Button variant="contained" color='secondary' onClick={backMenu}>Back</Button>
            } */}
        <Grid xs={12}>
          <Grid
            container
            sx={{
              flexDirection: "row",
              alignItems: "center",
              borderBottom: 1,
              borderColor: "#D9D9D9",
              px: 2,
              gap: 2,
            }}
          >
            <Grid item xs={3}>
              <Typography
                sx={{
                  color: "#DB8829",
                  fontSize: "1.2rem",
                  fontWeight: "900",
                  p: 2,
                }}
              >
                Pod Class
              </Typography>
            </Grid>
            <Grid item xs={8}>
              <Grid container>
                <Grid item xs={8}>
                  <FormControl sx={{ m: 1 }} size="small">
                    <Grid container sx={{ gap: 1 }}>
                      <Grid xs={5}>
                        <TextField
                          label="Podcast Title*"
                          variant="outlined"
                          size="small"
                          value={podcastTitle}
                          onInput={(val) => {
                            setPodcastTitle(val.target.value);
                          }}
                        />
                      </Grid>
                      <Grid xs={6}>
                        <FormControl sx={{ width: "100%" }} size="small">
                          <Select
                            value={selectedTrainers}
                            onChange={(item) => {
                              setSelectedTrainers(item.target.value);
                            }}
                            displayEmpty
                            inputProps={{
                              "aria-label": "Without label",
                              placeholder: "Select Trainer",
                            }}
                            placeholder="Select Trainer"
                          >
                            <MenuItem value="" disabled>
                              <span>Approving Trainer*</span>
                            </MenuItem>
                            {trainers &&
                              trainers.map((val, index) => {
                                return (
                                  <MenuItem
                                    value={val.value}
                                    key={`${index}_trainer_key`}
                                  >
                                    {val.name}
                                  </MenuItem>
                                );
                              })}
                          </Select>
                        </FormControl>
                      </Grid>
                    </Grid>
                  </FormControl>
                </Grid>
                <Grid
                  item
                  xs={4}
                  sx={{ display: "flex", flexDirection: "row" }}
                >
                  <SettingsModal
                    typesData={tempTypes}
                    classesList={allClasses}
                    selectClassForSettings={(classVal, typeindex) => {
                      selectClassToSave(classVal, typeindex, "classes");
                    }}
                    typeStringChnage={(txt, typeindex) => {
                      selectClassToSave(txt, typeindex, "string");
                    }}
                    saveSettingsRecord={saveSettings}
                    visible={modlVisible}
                    toggleVisibility={(flag) => {
                      setModlVisible(flag);
                    }}
                  ></SettingsModal>
                  <FormControl sx={{ width: "100%", m: 1, ml: 2 }} size="small">
                    <Select
                      value={selectedType}
                      onChange={(item) => {
                        setSelectedClass([]);
                        setSelectedLearners([]);
                        setSelectedType(item.target.value);
                      }}
                      inputProps={{
                        "aria-label": "Without label",
                      }}
                    >
                      {types &&
                        types.map((val1, indextype) => {
                          return (
                            <MenuItem
                              value={val1.value}
                              key={`${indextype}_value`}
                            >
                              {val1.name}
                            </MenuItem>
                          );
                        })}
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <Grid
            container
            sx={{
              flexDirection: "row",
              justifyContent: "flex-start",
            }}
          >
            <Grid item xs={12}>
              <Box
                sx={{
                  border: 1,
                  borderColor: "#EAECEE",
                  borderRadius: 5,
                  py: 2,
                  mx: 6,
                  mt: 2,
                  height: "60vh",
                }}
              >
                <Grid
                  container
                  sx={{
                    flexDirection: "row",
                    flexFlow: "wrap",
                    justifyContent: "flex-start",
                    px: 2,
                    mt: 1,
                  }}
                >
                  <Grid
                    item
                    xs={6}
                    sx={{
                      borderRight: 2,
                      borderColor: "#EAECEE",
                    }}
                  >
                    <Grid container>
                      <Grid
                        item
                        xs={12}
                        sx={{ pr: 5, height: "59vh", overflow: "auto" }}
                        className={classesName.scrollBar}
                      >
                        <List sx={{ py: 0, px: 1, width: "90%" }}>
                          {selectedLearners &&
                            selectedLearners.map((val, index2) => {
                              return (
                                <ListItem
                                  disablePadding
                                  key={`${index2}_learner`}
                                  sx={{
                                    borderBottom: 1,
                                    borderBottomColor: "#CCC",
                                  }}
                                  secondaryAction={
                                    <IconButton
                                      edge="end"
                                      au6ria-label="comments"
                                      sx={{ color: "primary.main" }}
                                      size="small"
                                      onClick={() => {
                                        addRemoveLearner(val);
                                      }}
                                    >
                                      <DeleteIcon
                                        sx={{
                                          color: "#c40000",
                                          fontSize: "1rem",
                                          "@media (min-width: 1636px)": {
                                            fontSize: "1.4rem",
                                          },
                                        }}
                                      />
                                    </IconButton>
                                  }
                                >
                                  <ListItemText sx={{ color: "primary.main" }}>
                                    <Typography
                                      sx={{
                                        fontSize: "0.8rem",
                                        fontWeight: "500",
                                        "@media (min-width: 1636px)": {
                                          fontSize: "1.2rem",
                                        },
                                      }}
                                    >
                                      {val.name
                                        ? `${index2 + 1}. ${joinByKeys(
                                            val.name,
                                            ["firstname", "lastname"],
                                            " "
                                          )}-(${val.classname})`
                                        : ""}
                                    </Typography>
                                  </ListItemText>
                                </ListItem>
                              );
                            })}
                        </List>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item xs={6} sx={{}}>
                    <Box
                      sx={{
                        mt: 1,
                        px: 3,
                      }}
                    >
                      <Grid container>
                        <Grid xs={12}>
                          <Typography
                            variant="subtitle2"
                            ml={2}
                            color={"primary"}
                          >
                            Select Class(es)
                          </Typography>
                          <FormControl fullWidth sx={{ mx: 1 }} size="small">
                            <Select
                              value={selectedClass}
                              id="demo-simple-select-label"
                              displayEmpty
                              multiple
                              renderValue={(selected) => {
                                return map(selected, "value").join(", ");
                              }}
                              inputProps={{ "aria-label": "Without label" }}
                            >
                              {allClasses &&
                                allClasses.map((val, index1) => {
                                  return (
                                    <MenuItem
                                      value={val.id}
                                      key={`${index1}_trainer_key`}
                                      disabled={
                                        types[selectedType][
                                          "classes"
                                        ].findIndex((o) => o.id == val.id) == -1
                                      }
                                    >
                                      <Checkbox
                                        checked={selectedClass.find(
                                          (o) => o.id == val.id
                                        )}
                                        onClick={() => {
                                          selectClass(val);
                                        }}
                                      />
                                      <ListItemText
                                        primary={val.value}
                                        onClick={() => {
                                          selectClass(val);
                                        }}
                                      />
                                    </MenuItem>
                                  );
                                })}
                            </Select>
                          </FormControl>
                        </Grid>
                        <Box
                          className={classesName.scrollBar}
                          sx={{
                            width: "100%",
                            height: "50vh",
                            overflow: "auto",
                            mr: 2,
                            mb: 2,
                          }}
                        >
                          <Grid xs={12}>
                            <FormControl sx={{ p: 2, width: "90%" }}>
                              <FormLabel
                                sx={{ color: "#DB8829", fontWeight: "600" }}
                              >
                                Learner List
                              </FormLabel>
                              <List sx={{ py: 0, px: 1, width: "90%" }}>
                                {selectedClassLearners &&
                                  selectedClassLearners.map((val, index2) => {
                                    return (
                                      <ListItem
                                        disablePadding
                                        key={`${index2}_learner`}
                                      >
                                        <ListItemButton
                                          sx={{ borderRadius: 15, py: 0 }}
                                          onClick={() => {
                                            addRemoveLearner(val);
                                          }}
                                        >
                                          <ListItemIcon>
                                            <CircleIcon
                                              fontSize="small"
                                              value="a"
                                              name="radio-buttons"
                                              sx={{
                                                color:
                                                  selectedLearners.findIndex(
                                                    (o) => o.uid === val.uid
                                                  ) > -1
                                                    ? "#DB8829"
                                                    : "#D9D9D9",
                                              }}
                                            />
                                          </ListItemIcon>
                                          <ListItemText
                                            sx={{ color: "primary.main" }}
                                          >
                                            <Typography
                                              sx={{
                                                fontSize: "0.8rem",
                                                fontWeight: "500",
                                                "@media (min-width: 1636px)": {
                                                  fontSize: "1.2rem",
                                                },
                                              }}
                                            >
                                              {val.name
                                                ? `${joinByKeys(
                                                    val.name,
                                                    ["firstname", "lastname"],
                                                    " "
                                                  )}-(${val.classname})`
                                                : ""}
                                            </Typography>
                                          </ListItemText>
                                        </ListItemButton>
                                      </ListItem>
                                    );
                                  })}
                              </List>
                            </FormControl>
                          </Grid>
                        </Box>
                      </Grid>
                    </Box>
                    {/* <Grid item xs={12} sx={{ textAlign: "right" }}>
                      <Button
                        variant="contained"
                        size="small"
                        sx={{
                          px: 5,
                          mt: 2,
                          borderRadius: 15,
                          backgroundColor: "primary.main",
                          color: "#FFFFFF",
                          height: "2rem",
                          textTransform: "inherit",
                         
                          fontWeight: "500",
                          "@media (min-width: 1636px)": {
                            fontSize: "1.4rem",
                            height: "3rem",
                          },
                        }}
                      >
                        Save
                      </Button>
                    </Grid> */}
                  </Grid>
                </Grid>
              </Box>
            </Grid>
            <Grid item xs={12} sx={{ mt: 2, mx: 6 }}>
              <Grid
                container
                sx={{
                  flexDirection: "row",
                  justifyContent: "space-between",
                  alignItems: "center",
                  px: 2,
                }}
              >
                <Grid>
                  <FormControl fullWidth sx={{ m: 1 }} size="small">
                    <Grid container sx={{ gap: 2 }}>
                      <Grid xs={12}>
                        <TextField
                          label="Guest Name"
                          variant="outlined"
                          size="small"
                          fullWidth
                          value={podcastGuestName}
                          onInput={(val) => {
                            setPodcastGuestName(val.target.value);
                          }}
                        />
                      </Grid>
                    </Grid>
                  </FormControl>
                </Grid>

                <Button
                  variant="contained"
                  size="small"
                  sx={{
                    px: 3,
                    mr: 2,
                    mt: 2,
                    borderRadius: 15,
                    fontSize: "1.2rem",
                    backgroundColor: "primary.main",
                    color: "#FFFFFF",
                    textTransform: "inherit",
                   
                    fontWeight: "500",
                    "@media (min-width: 1636px)": {
                      fontSize: "1.4rem",
                      height: "3rem",
                    },
                  }}
                  onClick={validateForm}
                >
                  Submit
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Confirmation
        visible={alertFlag}
        primaryText={currentMessage}
        image="error"
        alert={true}
        toggleModal={(flag) => setAlertFlag(flag)}
        timeout={3000}
      ></Confirmation>
      <Confirmation
        image="assign"
        primaryText="Podcast start"
        secondaryText="Do you want to start your podcast now?"
        visible={confirmModal}
        positiveClick={() => {
          setConfirmModal(false);
          navigation(-1);
        }}
        negativeClick={() => {
          setConfirmModal(false);
          navigation();
        }}
        toggleModal={(flag) => setConfirmModal(flag)}
        persistent={true}
      ></Confirmation>
    </Grid>
  );
};
const useStyles = makeStyles({
  scrollBar: {
    "&::-webkit-scrollbar": {
      width: "0.6em",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#ffe600ff",
      "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
      borderRadius: 5,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#5f5600ff",
      borderRadius: 5,
    },
  },
  scrollBarHeight: {
    "&::-webkit-scrollbar": {
      height: "0.6em",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#ffe600ff",
      "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
      borderRadius: 5,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#5f5600ff",
      borderRadius: 5,
    },
  },
  card: {
    backgroundColor: "#fff",
    borderRadius: 17,
    shadowColor: "#000",
    boxShadow: "2rem",
    paddingTop: "1rem",
  },
});
export default CreatePodcast;
